import React from "react";
import DfiBotDashboard from "./DfiBotDashboard";

// KUBERA theme — Royal Violet / Sapphire on deep violet-midnight (Vedic god of wealth, regime navigator)
const KUBERA_THEME = {
    name: "violet",
    bg: "#0b0420",
    hex: "#a855f7",
    hexHi: "#c084fc",
    text: "text-violet-300",
    textSoft: "text-violet-400",
    textSoft2: "text-violet-300/80",
    textSoft3: "text-violet-300/70",
    border: "border-violet-400/30",
    borderSoft: "border-violet-400/40",
    borderDim: "border-violet-400/20",
    bgGlow: "bg-violet-400/5",
    divide: "divide-violet-400/10",
    glow: "drop-shadow-[0_0_30px_rgba(168,85,247,0.5)]",
    bar: "bg-violet-400",
    hairline: "bg-violet-400/40",
    gridLine: "rgba(168,85,247,0.1)",
    accentDot: "bg-violet-400",
};

const kubera = {
    name: "KUBERA",
    tagline: "Regime-Shift Navigator · Two-faced vol harvester.",
    subTitle: "Dual-engine fade · 6 FX majors · 0.4% risk / trade · regime-gated · $100K institutional baseline",
    status: "LIVE · REGIME-GATED",
    statusTone: "text-violet-300 border-violet-400/40 bg-violet-400/5",
    theme: KUBERA_THEME,
    baseCapital: 100000,
    annualApy: "+45.70%",
    monthlyApy: "3.19%",
    periodReturn: 0.457, // scaled over kline window for visual
    kpis: [
        { value: "+45.70%", label: "Backtest CAGR",      sub: "2.79-year directional edge" },
        { value: "3.36",    label: "Sharpe (Daily)",     sub: "institutional-grade" },
        { value: "-8.62%",  label: "Max Drawdown",       sub: "regime + MTD guardrails" },
        { value: "1.53",    label: "Profit Factor",      sub: "no-churn threshold ≥ 1.20" },
        { value: "60-120%", label: "Target Net APY",     sub: "regime-active band" },
    ],
    streams: [
        {
            title: "Engine A · Fake-Break Fade",
            rate: "primary edge",
            alloc: "dynamic",
            detail:
                "Breakouts beyond Asia-range high / low that print a subsequent inside bar. Classic London-session reversal fade.",
        },
        {
            title: "Engine B · Range-Extreme Touch-and-Reject",
            rate: "secondary edge",
            alloc: "dynamic",
            detail:
                "Touch of Asia-range extreme with immediate rejection. Captures the fade with no breakout required.",
        },
        {
            title: "Guardrail 1 · MTD Drawdown",
            rate: "risk cut",
            alloc: "0.4% → 0.2%",
            detail:
                "If month-to-date drawdown ≤ -6%, risk per trade halves (0.4% → 0.2%) for remainder of month.",
        },
        {
            title: "Guardrail 2 · Regime Filter",
            rate: "18% trades filtered",
            alloc: "signal-based",
            detail:
                "Realised-volatility + trend-strength filter skips the 18% of signals that fire in non-ideal regimes.",
        },
    ],
    notes: [
        "6 FX majors live: EUR/USD · GBP/USD · USD/JPY · AUD/USD · USD/CAD · EUR/JPY. CHF rejected (SNB intervention risk).",
        "Dual engine stacked on 1H bars. Risk per trade 0.4%, auto-cut to 0.2% during drawdown months.",
        "515 trades per year expected · rebate contribution ≈ $36,040 per $100K per year on top of directional yield.",
        "Executes on Vantage MT5. Leverage self-capped 5× regardless of broker allowance.",
        "Backtest 2.79y: $100,000 → $285,710 compounded · regime-gated capital stays dormant in Veda yield when inactive.",
    ],
};

export default function DfiKubera() {
    return <DfiBotDashboard bot={kubera} />;
}
